import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eeb2bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "antialiased text-gray-700 bg-gray-100" }
const _hoisted_2 = {
  id: "app",
  class: "flex w-full h-screen justify-center items-center"
}
const _hoisted_3 = { class: "w-full max-w-xl p-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-3xl text-center text-indigo-700" }, " Login ", -1))
const _hoisted_5 = { class: "bg-white p-12 rounded-lg shadow-lg w-full mt-8" }
const _hoisted_6 = { class: "login-outer" }
const _hoisted_7 = {
  key: 0,
  class: "warning-container"
}
const _hoisted_8 = { class: "warning" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orbit-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" }),
  /*#__PURE__*/_createElementVNode("div", { class: "orbit" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Logging In...", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "text",
              placeholder: "Email",
              style: {"margin-bottom":"10px"}
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        (_ctx.warning != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.warning), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
          : (_openBlock(), _createElementBlock("button", {
              key: 2,
              ref: "loginButton",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loginClicked && _ctx.loginClicked(...args))),
              class: "block mt-4 rounded-lg py-2 px-6 text-lg hover:bg-gray-100 cursor-pointer next-button"
            }, "Login", 512))
      ])
    ])
  ]))
}